var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStackedLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "stacked-line",
  d: "M1 23h23v1H0V0h1z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#435370",
  xlinkHref: "#stacked-line"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4569A5",
  d: "M3 15h5v6H3zm7-3h5v9h-5zm7 2h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#97C2EA",
  d: "M3 11h5v3H3zm7-4h5v4h-5zm7 2h5v4h-5zm1.373-6.29a1.25 1.25 0 1 1-.036.999l-4.622-.165a1.25 1.25 0 0 1-2.254.401L6.75 5.796a1.25 1.25 0 1 1-.366-.93l4.906-1.927a1.25 1.25 0 0 1 2.237-.403z"
}))));
export default SvgStackedLine;